module.exports = __webpack_public_path__ + "img/slide2.4855cee3.png";